import React, { ReactNode, useCallback, useState } from 'react';

import { ImageWrapper } from '../../../common/wrappers/ImageWrapper';
import MLittlePrinceCarousel from '../carousels/MLittlePrinceCarousel';
import ateny from '../../../../assets/images/games/m-game/planets/ateny.webp';
import bardejov from '../../../../assets/images/games/m-game/planets/bardejov.webp';
import bruno from '../../../../assets/images/games/m-game/planets/bruno.webp';
import cajovna from '../../../../assets/images/games/m-game/planets/cajovna.webp';
import chorvatsko from '../../../../assets/images/games/m-game/planets/chorvatsko.webp';
import cukrovavata from '../../../../assets/images/games/m-game/planets/cukrovavata.webp';
import hluboka from '../../../../assets/images/games/m-game/planets/hluboka.webp';
import imageLast from '../../../../assets/images/games/m-game/planets/last.webp';
import karolinka from '../../../../assets/images/games/m-game/planets/karolinka.webp';
import koniklece from '../../../../assets/images/games/m-game/planets/koniklece.webp';
import kromeriz from '../../../../assets/images/games/m-game/planets/kromeriz.webp';
import letnekino from '../../../../assets/images/games/m-game/planets/letnekino.webp';
import macky from '../../../../assets/images/games/m-game/planets/macky.webp';
import petrov from '../../../../assets/images/games/m-game/planets/petrov.webp';
import ples from '../../../../assets/images/games/m-game/planets/ples.webp';
import plesvut from '../../../../assets/images/games/m-game/planets/plesvut.webp';
import priehrada from '../../../../assets/images/games/m-game/planets/priehrada.webp';
import prince from '../../../../assets/images/games/m-game/planets/prince.webp';
import puzzle from '../../../../assets/images/games/m-game/planets/puzzle.webp';
import silvester from '../../../../assets/images/games/m-game/planets/silvester.webp';
import spilberk from '../../../../assets/images/games/m-game/planets/spilberk.webp';
import statnice from '../../../../assets/images/games/m-game/planets/statnice.webp';
import svadba from '../../../../assets/images/games/m-game/planets/svadba.webp';
import tabor from '../../../../assets/images/games/m-game/planets/tabor.webp';
import tabor2 from '../../../../assets/images/games/m-game/planets/tabor2.webp';
import telc from '../../../../assets/images/games/m-game/planets/telc.webp';
import trhy from '../../../../assets/images/games/m-game/planets/trhy.webp';
import vegan from '../../../../assets/images/games/m-game/planets/vegan.webp';
import zdar from '../../../../assets/images/games/m-game/planets/zdar.webp';
import zivydabing from '../../../../assets/images/games/m-game/planets/zivydabing.webp';

export default function MLittlePrinceCipher() {
    const [selectedSlide, setSelectedSlide] = useState(0);
    const [images, setImages] = useState([
        { url: bardejov, id: 1 },
        { url: bruno, id: 2 },
        { url: cajovna, id: 3 },
        { url: letnekino, id: 4 },
        { url: ples, id: 5 },
        { url: plesvut, id: 6 },
        { url: priehrada, id: 7 },
        { url: silvester, id: 8 },
        { url: spilberk, id: 9 },
        { url: statnice, id: 10 },
        { url: tabor, id: 11 },
        { url: trhy, id: 12 },
        { url: vegan, id: 13 },
        { url: zdar, id: 14 },
        { url: zivydabing, id: 15 },
        { url: ateny, id: 16 },
        { url: cukrovavata, id: 17 },
        { url: hluboka, id: 18 },
        { url: chorvatsko, id: 19 },
        { url: karolinka, id: 20 },
        { url: koniklece, id: 21 },
        { url: kromeriz, id: 22 },
        { url: macky, id: 23 },
        { url: petrov, id: 24 },
        { url: puzzle, id: 25 },
        { url: svadba, id: 26 },
        { url: tabor2, id: 27 },
        { url: telc, id: 28 },
        { url: imageLast, id: 100 },
    ]);

    const [films, setFilms] = useState([
        { name: 'čajovňa na konci vesmíru', id: 3 },
        { name: 'planétka L+M', id: 26 },
        { name: 'pod Petrovom', id: 24 },
        { name: 'Cukrové ostrovčeky', id: 17 },
        { name: 'Mačací poloostrov', id: 23 },
        { name: 'U Karolínky', id: 20 },
        { name: 'Rokfort', id: 25 },
        { name: 'Chorvátske pobrežie', id: 19 },
        { name: 'slávny Vegan Sweet Bar', id: 13 },
        { name: 'Hluboká čierna diera', id: 18 },
        { name: 'VUT PX2019', id: 6 },
        { name: 'stratené mesto Atény', id: 16 },
        { name: 'Kino Scala na skale', id: 15 },
        { name: 'Kroměřížska hmlovina', id: 22 },
        { name: 'Bardejovský pás asteroidov', id: 1 },
        { name: 'Brunova planéta', id: 2 },
        { name: 'Súhvezdie Telč', id: 28 },
        { name: 'Galaxia Nová Zbrojovka', id: 4 },
        { name: 'Ples na fialovej planéte', id: 5 },
        { name: 'Priehrada na ľadovej planéte', id: 7 },
        { name: 'hviezda Silvester', id: 8 },
        { name: 'štátnicová supernova', id: 10 },
        { name: 'Koniklecová lúka', id: 21 },
        { name: 'Tábor polokrvných 2018', id: 11 },
        { name: 'Vianočné trhy', id: 12 },
        { name: 'roklina Žďár nad Sázavou', id: 14 },
        { name: 'Hrad Špilberk', id: 9 },
        { name: 'Záliv Maracaibo 2019', id: 27 },
    ]);

    const onCompleteSlide = useCallback((idx: number, _item: ReactNode) => {
        setSelectedSlide(idx);
    }, []);

    const removeOnIndex = (n: number) => {
        if (n === images[selectedSlide].id) {
            const filteredImages = images.filter((v) => v.id !== n);
            const filteredFilms = films.filter((v) => v.id !== n);
            setImages(filteredImages);
            setFilms(filteredFilms);
        }
    };
    return (
        <React.Fragment>
            <div className="m-prince">
                <MLittlePrinceCarousel onCompleteSlide={onCompleteSlide} images={images} />
                {films && images && films.length > 0 && images.length > 1 && (
                    <div className="m-prince-names-wrapper">
                        {films?.map((f, i) => {
                            return (
                                <div className="m-prince-name" key={i} onClick={() => removeOnIndex(f.id)}>
                                    {f.name}
                                </div>
                            );
                        })}
                    </div>
                )}
                {!images ||
                    (images.length === 1 && (
                        <div className="m-prince-solved">
                            <div className="m-cipher-image">
                                <ImageWrapper src={prince} alt="cipher" shouldScroll={true} allowLightbox={false} />
                            </div>
                            Aháá našli sme ho!
                        </div>
                    ))}
            </div>
        </React.Fragment>
    );
}
